<template>
	
	<div class="buy">
		<app-header/>
		
		<div class="container">

			<div class="float-right">
				<button type="button" v-b-modal.modalFilters class="btn btn-primary">
					Filtros
				</button>
			</div>

			<div class="table table-padded">
				<table>
					<thead>
						<tr>
							<th>{{$t('table.date')}}</th>
							<th>{{$t('table.client')}}</th>
							<th>{{$t('table.carrier')}}</th>
							<th>{{$t('table.value')}}</th>
							<th>{{$t('table.payments')}}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in transactions" :key="index">
							<td>2018-10-20</td>
							<td>Juan David Restrepo</td>
							<td>Compra claro</td>
							
							<td>
								<h2 class="itemIndicator" :class="item.type == 'add' ? 'low' : ''">${{money(item.amount)}}</h2>
							</td>
							
							<td>
								<button v-b-modal.modalPayments class="actionBtnTable"><i class="material-icons" style="color: #dab51b;">remove_red_eye</i></button>

							</td>
						</tr>
					</tbody>
				</table>

				<app-pagination :data="data"/>
			</div>



			
		</div>

		<app-footer/>

		<b-modal id="payModal" title="Pagar">
			Hola
		</b-modal>

		<b-modal id="modalFilters" centered   class='box-modal' title = "Filtrar Consignaciones"  >

			<div class="box-modal"> 

				<div class="form-group">

					<label class='control-label'>Fecha </label>		
					<input type="Date"  class="form-control">		
				</div>


				<div class="form-group">
					<label class='control-label'>Usuario</label>
					<input type="text"  class="form-control">	
				</div>

			</div>    

		</b-modal>


		<b-modal id="modalPayments" ref="modalPayments" centered size="sm"  title="Abonos" >
			<div class="">
				<div class="table table-padded">
					<table>
						<thead>
							<tr>
								<th>{{$t('table.date')}}</th>
								<th>{{$t('table.value')}}</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in transactions" :key="index">
								<td>2018-10-20</td>
								<td>
									<h2 class="itemIndicator" :class="item.type == 'add' ? 'low' : ''">${{money(item.amount)}}</h2>
								</td>
							</tr>
						</tbody>
					</table>


				</div>
			</div>

		</b-modal>






	</div>
</template>


<script>
import { mapGetters } from "vuex";
// import { FETCH_TRANSACTIONS } from "@/store/actions.type";

import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import AppPagination from "@/components/AppPagination.vue";

export default {
  components: {
    AppHeader,
    AppFooter,
    AppPagination
  },
  data: function() {
    return {
      form: {},
      data: {},
      operators: ["Claro", "Tigo", "Virgin", "Movistar", "Avantel", "Conectame"]
    };
  },
  methods: {
    contact() {}
  },

  computed: {
    ...mapGetters(["transactions"])
  },

  mounted() {
    // this.$store.dispatch(FETCH_TRANSACTIONS);
  }
};
</script>


<style lang="scss">
.buy {
  input {
  }

  label {
    color: #7b7b7b;
    font-weight: 900;
    font-size: 18px;
  }
  select {
    -webkit-appearance: none;
  }

  .box-modal {
    h5 {
      color: #dab51b !important;
      font-weight: 900;
      font-size: 25px;
    }
  }

  .box-filters {
    padding: 20px;
    width: 359px;
    border-radius: 20px;
    box-shadow: 1px 4px 7px rgba(0, 0, 0, 0.38);
    float: right;

    button {
      width: 100%;
    }
  }
}
</style>
